import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PriceFormat extends Component {
    intl = new Intl.NumberFormat('cs', {
        style: 'currency',
        currency: 'CZK',
        minimumFractionDigits: this.props.minimumFractionDigits
            ? this.props.minimumFractionDigits
            : 0
    });
    render() {
        const finalPrice = Math.round(this.props.value);

        if (window.Intl && typeof window.Intl === 'object') {
            return <span>{this.intl.format(finalPrice)}</span>;
        } else {
            return <span>{finalPrice} Kč</span>;
        }
    }
}

PriceFormat.propTypes = {
    value: PropTypes.number.isRequired,
    minimumFractionDigits: PropTypes.number
};
